import { EMBARGO_MESSAGE_KEYS, EMBARGO_VIOLATION_LEVELS } from '../constants';
import type { EmbargoRuleEvaluator, EmbargoViolation } from '../types';
import { isValueInCategory } from '../utils/listMatchers';

/** Destination zip is on the non-service zip list. */
export const nonServiceZipRule: EmbargoRuleEvaluator = {
  id: EMBARGO_MESSAGE_KEYS.NON_SERVICE_ZIP,
  level: EMBARGO_VIOLATION_LEVELS.SHIPMENT,
  evaluate: (context, config): EmbargoViolation[] => {
    if (!config.nonServiceZip.values.length) {
      return [];
    }

    return context.shipments.reduce<EmbargoViolation[]>((acc, shipment) => {
      if (!shipment.destinationZip) {
        return acc;
      }
      if (!isValueInCategory(shipment.destinationZip, config.nonServiceZip)) {
        return acc;
      }
      return [
        ...acc,
        {
          level: EMBARGO_VIOLATION_LEVELS.SHIPMENT,
          messageKey: EMBARGO_MESSAGE_KEYS.NON_SERVICE_ZIP,
          ruleId: EMBARGO_MESSAGE_KEYS.NON_SERVICE_ZIP,
          validationType: config.nonServiceZip.validationType,
          shipmentRowId: shipment.rowId,
        },
      ];
    }, []);
  },
};
